import { height, margin, maxWidth } from "@mui/system";

const styles = (theme) => ({
  cardSubText: {
    fontWeight: 500,
    fontSize: "20px",

    mb: 0.4,
    "@media (max-width: 600px)": {
      fontSize: "16px",
      mb: 0.1,
    },
  },
  containerComponent: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    width: "100%",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  paperDatagrid: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    height: "100%",
  },
  paper: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "100%",
    borderRadius: "16px",
    position: "relative",
    overflow: "hidden",
  },
  containerCardData: {
    width: "265px",

    display: "flex",
    flexDirection: "column",
    margin: "15px 0 0 0",
    height: "200px",
  },
  containerCardDataTitle: {
    width: "100%",
    borderRadius: "10px 10px 0 0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
    alignItems: "center",
    gap: 1,
    margin: "0 0 5px 0",
  },

  containerGrid: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
});

export default styles;
